<template lang="pug">
  .container
    router-view
</template>

<script>
export default {
  name: 'PatientLayout',
}
</script>
